import * as React from "react";
import type { SVGProps } from "react";
const SvgUserIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <defs>
      <clipPath id="c00d011e98bc816336596ae644a5be83-a">
        <circle cx={16} cy={16} r={15.145} fill="none" />
      </clipPath>
    </defs>
    <circle
      cx={16}
      cy={16}
      r={15.145}
      fill="none"
      stroke="currentcolor"
      strokeMiterlimit={10}
    />
    <g
      fill="none"
      stroke="currentcolor"
      strokeMiterlimit={10}
      clipPath="url(#c00d011e98bc816336596ae644a5be83-a)"
    >
      <ellipse
        cx={16}
        cy={32.553}
        strokeWidth={1.138}
        rx={15.406}
        ry={11.888}
      />
      <circle cx={16} cy={12.281} r={6.235} />
    </g>
  </svg>
);
export default SvgUserIcon;
